const DateService = {
  getToday: () => {
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    return today;
  },

  getDaysFromToday: days => {
    const date = DateService.getToday();
    date.setDate(date.getDate() + days);
    return date;
  },

  isWeekday: date => {
    const day = date.getDay();
    return day !== 0 && day !== 6;
  },

  isWithinDaysFromToday: (date, days) => {
    const target = new Date(date);
    target.setHours(0, 0, 0, 0);
    return target <= DateService.getDaysFromToday(days);
  },

  getNextBookableDays: calendarDays => {
    const result = [];
    const start = DateService.getToday();
    for (let i = 0; i <= calendarDays; i++) {
      const date = new Date(start);
      date.setDate(start.getDate() + i);
      if (DateService.isWeekday(date)) {
        result.push(date);
      }
    }
    return result;
  },

  // Get last day of the month after next by subtracting 1 day
  getEndOfFirstBillingPeriod: startDate => {
    const firstOfMonthAfterNext = new Date(
      startDate.getFullYear(),
      startDate.getMonth() + 2,
      1
    );
    return new Date(firstOfMonthAfterNext - 1);
  },

  formatDate: date => {
    const d = new Date(date);
    const year = d.getFullYear();
    const month = String(d.getMonth() + 1).padStart(2, '0');
    const day = String(d.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}T00:00:00`;
  },
};

export default DateService;
